import Base from './Base'

class InstrumentStatusReport extends Base {
  static className = 'InstrumentStatusReport'

  static intervals = {
    monthly: 'Monthly',
    weekly: 'Weekly',
    daily: 'Daily'
  }

  static reportTypes = {
    fire_alarm: 'Fire alarms report',
    temp_sensor: 'Temperature report',
    temp_sensor_daily: 'Temperature report (daily measurements)',
    people_counter: 'People count report',
    alarm_log: 'Alarm log'
  }

  static define() {
    this.belongsTo('organization')
    this.belongsTo('tag')
    this.belongsTo('instrument')
    this.attributes('name', 'interval', 'reportType', 'receiverEmails', 'disabled', 'disabledAt')
  }
}

export default Base.createResource(InstrumentStatusReport)
